// extracted by mini-css-extract-plugin
export default {"input-number":"numberInput_input-number__DrDvC"};